import React from 'react';
import { SubContainer } from '../../../certificates-constancies/type1/info/components';
import Spinner from '@/presentation/components/Spinner';
import NotAvailableModal from '@/presentation/modules/procedures/components/Modals/NotAvailable';
import RequestExist from '@/presentation/modules/procedures/components/Modals/RequestExists';
import { ProcedureInfoComponent } from './components/ProcedureInfoComponent';
import Modal from '../../../../components/Modal/Modal';
import ErrorModalPSE from './components/ErrorModalPSE';
import ProcedureHeader from '@/presentation/modules/procedures/components/ContainerProcedure/Header';
import ModuleContainer from '@/presentation/components/Container';
import { SubsectionHeader } from '@/presentation/reusables/SectionHeader';
import ReusableButton from '@/presentation/reusables/Button';
import ErrorMessage from '@/presentation/components/Error';

interface PSEInfoProps {
  procedureSelectedInfo: any;
  isLoadingProcedureInfo?: boolean;
  errorInfo?: any;
  onBackButton: () => void;
  handleExistRequest: () => void;
  NotAvailable: {
    showNotAvailableModal: boolean;
    setShowNotAvailableModal: (error: boolean) => void;
  };
  ProcedureExists: {
    showProcedureExists: boolean;
    setShowProcedureExists: (error: boolean) => void;
  };
  handlerGoToExistingProcedure: () => void;
  errorModal: {
    showModalError: boolean;
    setShowModalError: (error: boolean) => void;
  };
}

const PseInfoView: React.FC<PSEInfoProps> = ({
  onBackButton,
  procedureSelectedInfo,
  isLoadingProcedureInfo,
  handleExistRequest,
  NotAvailable,
  ProcedureExists,
  handlerGoToExistingProcedure,
  errorModal,
  errorInfo
}) => {
  const { showNotAvailableModal } = NotAvailable;
  const { showProcedureExists } = ProcedureExists;
  const { showModalError } = errorModal;
  const renderLoadingOrError = () => {
    if (isLoadingProcedureInfo) {
      return <Spinner />;
    }
    if (!procedureSelectedInfo || errorInfo) {
      return <ErrorMessage />;
    }
    return null;
  };

  return (
    <>
      <ModuleContainer
        containerType="subsection"
        data-testid="cmp-pseInforView"
      >
        <SubsectionHeader
          title="Validación de seguro de salud"
          onClick={onBackButton}
        />
        <SubContainer>
          {renderLoadingOrError()}
          {procedureSelectedInfo && (
            <>
              <div style={{ marginBottom: 16 }}>
                <ProcedureHeader
                  amount={procedureSelectedInfo.amount}
                  duration={procedureSelectedInfo.duration}
                  date={procedureSelectedInfo.endDate}
                />
              </div>
              <ProcedureInfoComponent />
              <div style={{ paddingTop: 24 }}>
                <ReusableButton onClick={handleExistRequest}>
                  Empezar validación
                </ReusableButton>
              </div>
            </>
          )}
        </SubContainer>
      </ModuleContainer>

      <br />
      <Modal show={showModalError} handleClose={onBackButton}>
        <ErrorModalPSE
          handleClick={onBackButton}
          title={procedureSelectedInfo?.error?.title}
          subtitle={procedureSelectedInfo?.error?.description}
        />
      </Modal>

      <Modal show={showNotAvailableModal} handleClose={onBackButton}>
        <NotAvailableModal
          handleClick={onBackButton}
          textInformation="Todavía no se encuentra disponible la validación del Seguro de Salud para el siguiente ciclo."
          styled={{
            fontSize: 14,
            lineHeight: 20,
            fontWeight: 400
          }}
        />
      </Modal>
      <Modal
        show={showProcedureExists}
        handleClose={() => handlerGoToExistingProcedure()}
      >
        <RequestExist
          handleClick={() => handlerGoToExistingProcedure()}
          styled={{
            fontSize: 14,
            lineHeight: 20,
            fontWeight: 400
          }}
        />
      </Modal>
    </>
  );
};

export default PseInfoView;
